import React, { useEffect, useState } from "react";

export const GDPRWrapper = ({ children, group }) => {
  const [isConsentGiven, setIsConsentGiven] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      // Method 1: Check via ultimateGdpr API
      if (window.ultimateGdpr && typeof window.ultimateGdpr.getConsentGroups === "function") {
        const consentGroups = window.ultimateGdpr.getConsentGroups();
        console.log('GDPR consent groups:', consentGroups, 'Looking for:', group);
        setIsConsentGiven(consentGroups.includes(group));
        return;
      }

      // Method 2: Check cookie directly
      const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
      };

      const groupCookie = getCookie(group);
      console.log(`Cookie ${group}:`, groupCookie);

      if (groupCookie === 'true') {
        setIsConsentGiven(true);
        return;
      }

      // Default: no consent
      console.warn("GDPR plugin is not loaded or getConsentGroups is undefined.");
      setIsConsentGiven(false);
    };

    // Listen for consent updates
    document.addEventListener("ct-ultimate-gdpr-cookie-update", checkConsent);

    // Also check every 2 seconds (fallback)
    const intervalId = setInterval(checkConsent, 2000);

    // Initial check
    checkConsent();

    return () => {
      document.removeEventListener("ct-ultimate-gdpr-cookie-update", checkConsent);
      clearInterval(intervalId);
    };
  }, [group]);

  return isConsentGiven ? children : (
    <div style={{
      textAlign: 'center',
      padding: '40px 20px',
      background: '#f5f5f5',
      borderRadius: '8px',
      margin: '20px 0'
    }}>
      <p style={{
        fontSize: '16px',
        color: '#333',
        marginBottom: '15px'
      }}>
        Um dieses Video anzusehen, akzeptieren Sie bitte die Funktionscookies in Ihren Datenschutzeinstellungen.
      </p>
      <button
        onClick={() => {
          console.log('Cookie Settings button clicked');

          // Use jQuery (loaded in index.html)
          const $ = window.jQuery || window.$ || window.ct$;

          if (!$) {
            console.error('jQuery not found!');
            return;
          }

          console.log('jQuery found, trying to open modal...');

          // Method 1: Try to trigger the gear icon click
          const gearIcon = $('#ct-ultimate-gdpr-cookie-open');
          console.log('Gear icon found:', gearIcon.length);
          if (gearIcon.length > 0) {
            gearIcon.click();
            return;
          }

          // Method 2: Try the change settings button
          const settingsBtn = $('#ct-ultimate-gdpr-cookie-change-settings');
          console.log('Settings button found:', settingsBtn.length);
          if (settingsBtn.length > 0) {
            settingsBtn.click();
            return;
          }

          // Method 3: Show modal directly
          const modal = $('#ct-ultimate-gdpr-cookie-modal');
          console.log('Modal found:', modal.length);
          if (modal.length > 0) {
            modal.show();
            $('body').addClass('cookie-modal-open');
            $('html').addClass('cookie-modal-open');
            $('#ct-ultimate-gdpr-cookie-open').hide();
          } else {
            console.error('Could not find GDPR modal!');
          }
        }}
        style={{
          background: '#6a8ee7',
          color: 'white',
          border: 'none',
          padding: '12px 24px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 'bold',
          width:'max-content'
        }}
      >
        Cookie-Einstellungen
      </button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Utility/GDPRWrapper.js